import img from '../assets/Banners/Banner - 001_shorter.jpg'
import '../App.css'
import { Link } from 'react-router-dom'
import { BigMapIcon, BigChartIcon, BigContactIcon, BigCarIcon } from '../assets/icons'

export default function Home() {

    const preConPercent = 80;
    const conPercent = 30;
    const totalPercent = 55;

    return (
        <div>
            <main className='flex-shrink-0 modular min-vh-100'>
                <div style={{ position: "relative", width: "100%" }}>
                    <img
                        src={img}
                        className="d-block w-100"
                        style={{ objectFit: "cover" }}
                        alt=''
                    />
                    <div style={{
                        position: "absolute",
                        top: "50%",
                        left: "0",
                        right: "0",
                        transform: "translateY(-50%)",
                        textAlign: "center",
                    }}>
                        <div className="container">
                            <h1 style={{ fontWeight: '600', fontSize: 'clamp(0.8rem, 3vw, 2.5rem)' }} id="bannerText">
                                2023 Parker County Transportation Bond Program
                            </h1>
                        </div>
                    </div>
                </div>
                <div className="container py-4">
                    <div className='row'>
                        <div className='col-12 col-lg-6 my-1'>
                            <div className="card shadow">
                                <div className="card-body">
                                    <h4 className='text-start'>Program Description</h4>
                                    <p style={{ lineHeight: "28px" }}>
                                        The purpose of the Parker County Transportation Bond Program is to meet critical transportation infrastructure needs across Parker County through the financing of strategically significant projects. The population in Parker County grew by over 34% from 2010-2022 and is currently growing at a rate of just under 5%.  To keep up with the growth a $130M bond program consisting of 32 projects was proposed.  Voters approved this bond at the November 7, 2023 election.  Through this bond program the County will be able to not only leverage additional state and/or federal funding as it becomes available but also leverage partnerships with surrounding communities to provide strategic projects for their area.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-lg-6 my-1'>
                            <div className='card shadow'>
                                <div className='card-body'>
                                    {
                                        preConPercent != null || conPercent != null ? <>
                                            <h4 className='text-start'>Program Progress</h4>
                                        </> : <></>
                                    }
                                    {preConPercent != null ? <>
                                        <div className="px-1">
                                            <svg width="100%" height="80" viewBox="-60 -20 920 120" preserveAspectRatio="xMidYMid meet">
                                                <rect
                                                    x="0"
                                                    y="20"
                                                    width={preConPercent * 8}
                                                    height="60"
                                                    fill="#2ca03d"
                                                    className="transition-all duration-500"
                                                />

                                                <rect
                                                    x={preConPercent * 8}
                                                    y="20"
                                                    width={(100 - preConPercent) * 8}
                                                    height="60"
                                                    fill="#4bce5e"
                                                    className="transition-all duration-500"
                                                />
                                                <rect
                                                    x={preConPercent * 8 - 50}
                                                    y="-20"
                                                    width="100"
                                                    height="55"
                                                    rx="8"
                                                    fill="white"
                                                    stroke="#e5e7eb"
                                                    strokeWidth="2"
                                                    className="transition-all duration-500"
                                                />
                                                <text
                                                    x={preConPercent * 8}
                                                    y="5"
                                                    fill="#1f2937"
                                                    fontSize="24"
                                                    fontWeight="bold"
                                                    textAnchor="middle"
                                                >
                                                    {preConPercent}%
                                                </text>
                                                <text
                                                    x={preConPercent * 8}
                                                    y="25"
                                                    fill="#6b7280"
                                                    fontSize="20"
                                                    textAnchor="middle"
                                                >
                                                    Complete
                                                </text>
                                            </svg>
                                            <h6 className='text-center'>Pre-construction Phase</h6>
                                        </div>
                                    </> : <></>}
                                    {conPercent != null ? <>
                                        <div className="px-1">
                                            <svg width="100%" height="80" viewBox="-60 -20 920 120" preserveAspectRatio="xMidYMid meet">
                                                <rect
                                                    x="0"
                                                    y="20"
                                                    width={conPercent * 8}
                                                    height="60"
                                                    fill="#ff6600"
                                                    className="transition-all duration-500"
                                                />

                                                <rect
                                                    x={conPercent * 8}
                                                    y="20"
                                                    width={(100 - conPercent) * 8}
                                                    height="60"
                                                    fill="#ffa366"
                                                    className="transition-all duration-500"
                                                />
                                                <rect
                                                    x={conPercent * 8 - 50}
                                                    y="-20"
                                                    width="100"
                                                    height="55"
                                                    rx="8"
                                                    fill="white"
                                                    stroke="#e5e7eb"
                                                    strokeWidth="2"
                                                    className="transition-all duration-500"
                                                />
                                                <text
                                                    x={conPercent * 8}
                                                    y="5"
                                                    fill="#1f2937"
                                                    fontSize="24"
                                                    fontWeight="bold"
                                                    textAnchor="middle"
                                                >
                                                    {conPercent}%
                                                </text>
                                                <text
                                                    x={conPercent * 8}
                                                    y="25"
                                                    fill="#6b7280"
                                                    fontSize="20"
                                                    textAnchor="middle"
                                                >
                                                    Complete
                                                </text>
                                            </svg>
                                            <h6 className='text-center'>Construction Phase</h6>
                                        </div>
                                    </> : <></>}

                                    {totalPercent != null ? <>
                                        <div className="px-1 row">
                                            <svg width="100%" height="80" viewBox="-60 -20 920 120" preserveAspectRatio="xMidYMid meet">
                                                <rect
                                                    x="0"
                                                    y="20"
                                                    width={totalPercent * 8}
                                                    height="60"
                                                    fill="#4668a0"
                                                    className="transition-all duration-500"
                                                />

                                                <rect
                                                    x={totalPercent * 8}
                                                    y="20"
                                                    width={(100 - totalPercent) * 8}
                                                    height="60"
                                                    fill="#7190c1"
                                                    className="transition-all duration-500"
                                                />
                                                <rect
                                                    x={totalPercent * 8 - 50}
                                                    y="-20"
                                                    width="100"
                                                    height="55"
                                                    rx="8"
                                                    fill="white"
                                                    stroke="#e5e7eb"
                                                    strokeWidth="2"
                                                    className="transition-all duration-500"
                                                />
                                                <text
                                                    x={totalPercent * 8}
                                                    y="5"
                                                    fill="#1f2937"
                                                    fontSize="24"
                                                    fontWeight="bold"
                                                    textAnchor="middle"
                                                >
                                                    {totalPercent}%
                                                </text>
                                                <text
                                                    x={totalPercent * 8}
                                                    y="25"
                                                    fill="#6b7280"
                                                    fontSize="20"
                                                    textAnchor="middle"
                                                >
                                                    Complete
                                                </text>
                                            </svg>
                                            <h6 className='text-center'>Total Progress</h6>
                                        </div>
                                    </> : <></>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3  text-center">
                        <div className='col-md-3 mb-2'>
                            <div className='card shadow'>
                                <Link to='/traffic' style={{ textDecoration: "none", color: "#4668a0" }}>
                                    <div className='card-body'>
                                        <BigCarIcon />
                                        <h5 className='my-2'>Go to Traffic Updates</h5>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className='col-md-3 mb-2'>
                            <div className='card shadow'>
                                <Link to='/reports' style={{ textDecoration: "none", color: "#4668a0" }}>
                                    <div className='card-body'>
                                        <BigChartIcon />
                                        <h5 className='my-2'>Go to Reports</h5>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className='col-md-3 mb-2'>
                            <div className='card shadow'>
                                <Link to='/projects' style={{ textDecoration: "none", color: "#4668a0" }}>
                                    <div className='card-body'>
                                        <BigMapIcon />
                                        <h5 className='my-2'>Go to Projects Map</h5>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className='col-md-3 mb-2'>
                            <div className='card shadow'>
                                <a href="mailto:Info@parkercountybond.com" title="Email us at Info@parkercountybond.com" style={{ textDecoration: "none", color: "#4668a0" }}>
                                    <div className='card-body'>
                                        <BigContactIcon />
                                        <h5 className='my-2'>Contact Us</h5>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </main >
        </div >
    )
}